export const TEST_ID = 'topRightArrowIcon';
